/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsDownUp = createReactComponent("arrows-down-up", "IconArrowsDownUp", [
  ["path", { d: "M17 3l0 18", key: "svg-0" }],
  ["path", { d: "M10 18l-3 3l-3 -3", key: "svg-1" }],
  ["path", { d: "M7 21l0 -18", key: "svg-2" }],
  ["path", { d: "M20 6l-3 -3l-3 3", key: "svg-3" }]
]);

export { IconArrowsDownUp as default };
//# sourceMappingURL=IconArrowsDownUp.js.map
